import AppConfig from "config";
import axios from "axios";



const ResultsController = {
  async listResults(jwtToken, auditName, startDate, endDate, agentName, supervisorName, tabulationName, questionName, AnswerName, contactStart, contactEnd) {
    try {
      const requestBody = {
        audit_name: auditName ?? 0
      };
      if (startDate && startDate.trim() !== '') {
        requestBody.date_start = startDate;
      }
      if (endDate && endDate.trim() !== '') {
        requestBody.date_end = endDate;
      }
      if (agentName && agentName.trim() !== '') {
        requestBody.agent_name = agentName;
      }
      if (supervisorName && supervisorName.trim() !== '') {
        requestBody.supervisor_name = supervisorName;
      }

      if (questionName && questionName.trim() !== '') {
        requestBody.question_name = questionName;
      }

      if (AnswerName && AnswerName.trim() !== '') {
        requestBody.resposta_resumida = AnswerName;
      }

      if (contactStart && contactStart.trim() !== '') {
        requestBody.date_event_start = contactStart;
      }
      if (contactEnd && contactEnd.trim() !== '') {
        requestBody.date_event_finish = contactEnd;
      }
      if (tabulationName && tabulationName.trim() !== '') {
        requestBody.tabulation = tabulationName;
      }
      const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/audit_content`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
            'Content-Type': 'application/json'
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async getAgentNames(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_agent_names`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching agent names:", error);
      throw error;
    }
  },
  async getSupervisorNames(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_supervisor_names`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching supervisor names:", error);
      throw error;
    }
  },
  async getTabulationNames(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_tabulation_names`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching supervisor names:", error);
      throw error;
    }
  },
  async getQuestions(jwtToken, auditId, startDate, endDate) {
    try {
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_questions`,
        {
          audit_id: auditId,
          date_start: startDate,
          date_end: endDate
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching questions:", error);
      throw error;
    }
  },
  async getAnswers(jwtToken, auditId, startDate, endDate) {
    try {
      const response = await axios.post(
        AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_answers`,
        {
          audit_id: auditId,
          date_start: startDate,
          date_end: endDate
        },
        {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching questions:", error);
      throw error;
    }
  },
  async listaudits(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `results_page/get_audits`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  },
  async listauditsActive(jwtToken) {
    try {
      const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO + `dashboard_page_front/get_audits`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching profiles:", error);
      throw error;
    }
  }
};

export default ResultsController;
